const translations: Record<string, Record<string, string>> = {
  en: {
    'player.loading': 'Loading',
    'player.loading.models': 'Loading models...',
    'player.loading.model': 'Loading model...',
    'player.loaded_of': '{loaded} of {total} loaded',
    'player.configure': 'Configure',
    'player.share': 'Share',
    'player.share.title': 'Share Configuration',
    'player.share.copy': 'Copy Link',
    'player.share.copied': 'Copied!',
    'player.share.qr': 'QR Code',
    'player.fullscreen': 'Fullscreen',
    'player.reset': 'Reset',
    'player.export': 'Export',
    'player.camera': 'Camera',
    'player.camera.front': 'Front',
    'player.camera.back': 'Back',
    'player.camera.left': 'Left',
    'player.camera.right': 'Right',
    'player.camera.top': 'Top',
    'player.environment': 'Environment',
    'player.shortcuts': 'Keyboard Shortcuts',
    'player.price': 'Price',
    'player.select_product': 'Select a product',
    'player.no_products': 'No products available',
    'player.error': 'Error',
    'player.retry': 'Retry',
    'player.swipe_close': 'Swipe to close',
    'player.swipe_open': 'Swipe to open',
    'player.skip_to_config': 'Skip to configuration options',
    'player.auto_rotate': 'Auto-rotate',
    'player.summary': 'Configuration Summary',
  },
  de: {
    'player.loading': 'Laden',
    'player.loading.models': 'Modelle laden...',
    'player.loading.model': 'Modell laden...',
    'player.loaded_of': '{loaded} von {total} geladen',
    'player.configure': 'Konfigurieren',
    'player.share': 'Teilen',
    'player.share.title': 'Konfiguration teilen',
    'player.share.copy': 'Link kopieren',
    'player.share.copied': 'Kopiert!',
    'player.share.qr': 'QR-Code',
    'player.fullscreen': 'Vollbild',
    'player.reset': 'Zurücksetzen',
    'player.export': 'Exportieren',
    'player.camera': 'Kamera',
    'player.camera.front': 'Vorne',
    'player.camera.back': 'Hinten',
    'player.camera.left': 'Links',
    'player.camera.right': 'Rechts',
    'player.camera.top': 'Oben',
    'player.environment': 'Umgebung',
    'player.shortcuts': 'Tastenkombinationen',
    'player.price': 'Preis',
    'player.select_product': 'Produkt auswählen',
    'player.no_products': 'Keine Produkte verfügbar',
    'player.error': 'Fehler',
    'player.retry': 'Wiederholen',
    'player.swipe_close': 'Wischen zum Schließen',
    'player.swipe_open': 'Wischen zum Öffnen',
    'player.skip_to_config': 'Zu Konfigurationsoptionen springen',
    'player.auto_rotate': 'Auto-Rotation',
    'player.summary': 'Konfigurationsübersicht',
  },
  fr: {
    'player.loading': 'Chargement',
    'player.loading.models': 'Chargement des modèles...',
    'player.loading.model': 'Chargement du modèle...',
    'player.loaded_of': '{loaded} sur {total} chargé(s)',
    'player.configure': 'Configurer',
    'player.share': 'Partager',
    'player.share.title': 'Partager la configuration',
    'player.share.copy': 'Copier le lien',
    'player.share.copied': 'Copié !',
    'player.share.qr': 'Code QR',
    'player.fullscreen': 'Plein écran',
    'player.reset': 'Réinitialiser',
    'player.export': 'Exporter',
    'player.camera': 'Caméra',
    'player.camera.front': 'Avant',
    'player.camera.back': 'Arrière',
    'player.camera.left': 'Gauche',
    'player.camera.right': 'Droite',
    'player.camera.top': 'Dessus',
    'player.environment': 'Environnement',
    'player.shortcuts': 'Raccourcis clavier',
    'player.price': 'Prix',
    'player.select_product': 'Sélectionner un produit',
    'player.no_products': 'Aucun produit disponible',
    'player.error': 'Erreur',
    'player.retry': 'Réessayer',
    'player.swipe_close': 'Balayer pour fermer',
    'player.swipe_open': 'Balayer pour ouvrir',
    'player.skip_to_config': 'Passer aux options de configuration',
    'player.auto_rotate': 'Rotation automatique',
    'player.summary': 'Résumé de la configuration',
  },
  es: {
    'player.loading': 'Cargando',
    'player.loading.models': 'Cargando modelos...',
    'player.loading.model': 'Cargando modelo...',
    'player.loaded_of': '{loaded} de {total} cargado(s)',
    'player.configure': 'Configurar',
    'player.share': 'Compartir',
    'player.share.title': 'Compartir configuración',
    'player.share.copy': 'Copiar enlace',
    'player.share.copied': '¡Copiado!',
    'player.share.qr': 'Código QR',
    'player.fullscreen': 'Pantalla completa',
    'player.reset': 'Restablecer',
    'player.export': 'Exportar',
    'player.camera': 'Cámara',
    'player.camera.front': 'Frontal',
    'player.camera.back': 'Trasera',
    'player.camera.left': 'Izquierda',
    'player.camera.right': 'Derecha',
    'player.camera.top': 'Superior',
    'player.environment': 'Entorno',
    'player.shortcuts': 'Atajos de teclado',
    'player.price': 'Precio',
    'player.select_product': 'Seleccionar un producto',
    'player.no_products': 'No hay productos disponibles',
    'player.error': 'Error',
    'player.retry': 'Reintentar',
    'player.swipe_close': 'Deslizar para cerrar',
    'player.swipe_open': 'Deslizar para abrir',
    'player.skip_to_config': 'Saltar a opciones de configuración',
    'player.auto_rotate': 'Rotación automática',
    'player.summary': 'Resumen de configuración',
  },
};

const SUPPORTED_LOCALES = Object.keys(translations);
const DEFAULT_LOCALE = 'en';

let currentLocale = DEFAULT_LOCALE;

export function setLocale(locale: string) {
  const lang = locale.split('-')[0].toLowerCase();
  currentLocale = SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
}

export function getLocale(): string {
  return currentLocale;
}

export function getSupportedLocales(): string[] {
  return [...SUPPORTED_LOCALES];
}

export function t(key: string, params?: Record<string, string | number>): string {
  const dict = translations[currentLocale] || translations[DEFAULT_LOCALE];
  let text = dict[key] || translations[DEFAULT_LOCALE][key] || key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(`{${k}}`, String(v));
    }
  }
  return text;
}

export function detectLocale(): string {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;

  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang') || urlParams.get('locale');
  if (langParam) {
    const lang = langParam.split('-')[0].toLowerCase();
    if (SUPPORTED_LOCALES.includes(lang)) return lang;
  }

  const browserLang = navigator.language?.split('-')[0].toLowerCase();
  if (browserLang && SUPPORTED_LOCALES.includes(browserLang)) return browserLang;

  return DEFAULT_LOCALE;
}
